export { default } from '@framework/tenant/config/openmarket';
